module.exports = "<div [class]=\"'modal-dialog' + (size ? ' modal-' + size : '')\" role=\"document\">\n    <div class=\"modal-content-wrapper\">\n        <div class=\"modal-content\">\n            <ng-content #content></ng-content>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/modals/components/window/window.component.html
// module id = ./libs/chassis-core/src/app/modals/components/window/window.component.html
// module chunks = main